export default function PageHeader({ title, subtitle, children }) {
  return (
    <div className="sticky top-0 z-20 backdrop-blur-xl bg-white/70 border-b border-black/5">
      <div className="px-10 py-6 flex items-end justify-between gap-6">
        <div>
          <h1 className="font-display text-3xl font-medium tracking-tight text-foreground">{title}</h1>
          {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-3">{children}</div>
      </div>
    </div>
  );
}
